const config = {
  id: 10,
  name: '商品',
  type: 1,
  module_code: 'biz_item',
  icon: 'icon-tms-item',
  font_icon: '&#xe723;',
  style_type: 2,
  link_type: 4,
  bg_color: '',
  margin_num: 0,
  link_data: [],
};

export default config;
